<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      width="640px"
      scrollable
      transition="slide-x-transition"
    >
      <v-card class="grid">
        <!-- close -->
        <v-toolbar elevation="0" class="title mb-8 mt-2">
          <v-btn class="icon-arrow" icon @click="handleClose">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <div style="display: grid; position: relative; top: 15px">
            <span
              :class="{
                'brand--text text--darken-2': !$vuetify.theme.dark,
              }"
              >{{ $t('message.pages.customizeModal.thisCycleDetails') }}</span
            >
            <span class="date-text">
              {{ formatData(prorataData.period_start) }} -
              {{ formatData(prorataData.period_end) }}</span
            >
          </div>

          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>


        <!-- steps -->
        <v-card-text
          v-if="prorataData"
          class="my-0 py-0 pl-6 pr-8"
          :class="moreDetails ? 'pl-6 pr-8' : 'pl-10 pr-12'"
          style="min-height: 311px"
        >
          <v-row no-gutters>
            <v-col cols="12" class="columnTitle mb-2">
              <v-row no-gutters>
                <v-col cols="10">
                  <span>ITEM</span>
                </v-col>
                <v-col cols="2">
                  <v-row no-gutters justify="end">
                    <span>{{ currencySign }}</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-row no-gutters v-for="(prorateObject, index) in prorataObjects" :key="`prorateObject-${index}`">
  <template v-for="(objLine, index) in prorateObject.objects">
    <v-row no-gutters :key="`objLine-${index}`" v-if="formatDescription(objLine.description) !== ''" 
           style="width: 100%; line-height: 15px !important" class="pr-0 py-2 border-bottom--gray">
      <v-col>
        <span class="number-desc"> {{ formatQuantity(objLine.quantity) }} </span>
        <span class="text-desc">{{ formatDescription(objLine.description) }}</span>
        <span> {{formatTextTime(objLine.description)}} {{formatTextDays(objLine.description)}}</span>
      </v-col>
      <v-col cols="2" class="d-flex justify-end">
        <span class="value-desc">{{ formatAmount(objLine.amount) }}</span>
      </v-col>
    </v-row>
  </template>
</v-row>


            <v-col cols="12" class="my-4">
              <v-divider class="mb-4"></v-divider>
              <v-row no-gutters>
                <v-col class="text-desc" cols="10">
                  <span>{{
                    $t('message.pages.customizeModal.totalToNext')
                  }}</span>
                </v-col>
                <v-col cols="2" v-if="prorataData && prorataData.amount_due">
                  <v-row no-gutters justify="end">
                    <span class="text-desc">{{
                      formatAmount(prorataData.amount_due)
                    }}</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import i18n from '@/translations/lang'

export default {
  name: 'CustomizePlanDetails',
  components: {},
  data: () => ({
    open: false,
    currentUse: 0,
    dontShow: false,
    currencySign: 'R$',
    prorataObjects: null,
    prorataData: null,
    items: [],
    moreDetails: false,
    currency: 'brl',
    currencyLocale: 'pt-BR',
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
  },
 async mounted() {
  await  this.$root.$on(
      'openCustomizePlanDetails',
      async (prorataObjects, allProrateData) => {
       await this.handleOpenedModal()
        this.open = true
        this.prorataObjects = prorataObjects
        this.prorataData = allProrateData
        this.currentDayUse()
      }
    )
  },
  beforeDestroy() {
    this.$root.$off('openCustomizePlanDetails')
  },
  methods: {
    handleOpenedModal() {
      this.setCurrencyConfig()
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    formatData(timestamp) {
      const data = new Date(timestamp * 1000)

      const dia = data.getDate().toString().padStart(2, '0')
      const mes = (data.getMonth() + 1).toString().padStart(2, '0')
      const ano = data.getFullYear().toString().slice(-2)

      return `${dia}/${mes}/${ano}`
    },
    timeConverter(timestamp) {
      let a = new Date(timestamp * 1000)
      let locale = this.getLocale().toLowerCase()
      let months
      if (locale === 'en-us') {
        months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ]
      } else {
        months = [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Maio',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ]
      }
      let month = months[a.getMonth()]
      let date = a.getDate()
      let time = month + ' ' + date
      return time.toUpperCase()
    },
    getProhataLabel({ end }) {
      if (this.isCurrentMonth({ end })) return 'current'
      if (this.isNextMonth({ end })) return 'next'
      return false
    },
    isCurrentMonth({ end }) {
      const dateObject = new Date(end * 1000)
      return (
        dateObject.getMonth() ===
        new Date(this.getPayTimeStamp * 1000).getMonth()
      )
    },
    isNextMonth({ end }) {
      const dateObject = new Date(end * 1000)
      return (
        dateObject.getMonth() ===
        new Date(this.getPayTimeStamp * 1000).getMonth() + 1
      )
    },

    formatQuantity(quantity) {
      const quantityStr = quantity.toString()
      if (quantityStr.includes('0.5')) {
        return '512 GB'
      } else {
        return quantity
      }
    },

    formatAmount(amount) {
      return (amount / 100).toLocaleString(this.currencyLocale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },

    currentDayUse() {
  const start = new Date(this.prorataData.period_start * 1000)
  const now = new Date()
  const differenceInMillis = now.getTime() - start.getTime()
  const differenceInDays = Math.floor(differenceInMillis / (1000 * 60 * 60 * 24))
  if (differenceInDays === 0) {
    this.currentUse = 1
  }
  else {
    this.currentUse = differenceInDays
  }
},

    formatTextTime (description) {
      if (description.toLowerCase().includes('tempo não utilizado')) {
        return i18n.t('message.pages.customizeModal.proportionalDays') + ` ${this.currentUse}`
      }
      return ''
    },

    formatTextDays (description) {
      if (description.toLowerCase().includes('tempo não utilizado')) {
        if (this.currentUse === 1) {
          return i18n.t('message.pages.customizeModal.proportionalDays3')
        }
        else {
        return i18n.t('message.pages.customizeModal.proportionalDays2')
        }
      } else {
        return ''
      }

    },

    formatDescription(description) {
      if (description.toLowerCase().includes('restante')) {
        return ''
      }
      if (description.toLowerCase().includes('bronze')) {
        return i18n.t('message.pages.customizeModal.bronzePlan')
      }
      if (description.toLowerCase().includes('silver')) {
        return i18n.t('message.pages.customizeModal.silverPlan')
      }
      if (description.toLowerCase().includes('gold')) {
        return i18n.t('message.pages.customizeModal.goldPlan')
      }
      if (description.toLowerCase().includes('armazenamento' || 'storage')) {
        return i18n.t('message.pages.customizeModal.ofStorage')
      }
      //banda
      if (
        description.toLowerCase().includes('banda') ||
        description.toLowerCase().includes('bandwidth')
      ) {
        return i18n.t('message.pages.customizeModal.ofBandwidth')
      }
      //live
      if (description.toLowerCase().includes('live')) {
        return i18n.t('message.pages.customizeModal.ofLive')
      }
      // user
      if (
        description.toLowerCase().includes('user') ||
        description.toLowerCase().includes('usuário')
      ) {
        return i18n.t('message.pages.customizeModal.ofUser')
      }

      return description
    },
    setCurrencyConfig() {
      const currency = this.userPlanInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencySign = '$'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currencySign = 'R$'
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    handleClose() {
      this.open = false
    },
    handleMoreDetails() {
      this.moreDetails = true
    },
    backToMain() {
      this.moreDetails = false
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  font-size: 18px;
}

.date-text {
  font-weight: 400;
  font-size: 14px;
  color: var(--v-neutral-base);
}

.text-desc {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--v-neutral-base);
}

.value-desc {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--v-neutral-base);
}

.number-desc {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--v-neutral-base);
}

.columnTitle {
  font-weight: 400;
  font-size: 12px;
}

.columnRow {
  font-weight: 400;
  font-size: 16px;
}

.text--current-month {
  text-transform: uppercase;
}

.text--month-listing {
  background: var(--v-progressBar-lighten1);
}

.text--month-listing--dark {
  background: #60606038;
}

.bg-dark {
  .number-desc {
    color: #ffffff;
  }
  .text-desc {
    color: #ffffff;
  }

  .value-desc {
    color: #ffffff;
  }
  .date-text {
    color: var(--v-primary-lighten1);
  }
  .icon-arrow {
    color: var(--v-primary-lighten1);
  }
}
</style>
